import {AbstractControl, FormControl} from '@angular/forms';
import { CommonConstants } from '../constants/common-constants.enum';

export function initialValidation(control: AbstractControl) {
  return (c: FormControl) => {
    return control.valid ? null : {invalid: true};
  };
}

export function setDefaultErrors(control: AbstractControl) {
  if (control) {
    control.setErrors({invalid: true});
  }
}

export function inputValidationMessage(control: AbstractControl): string {
  let validationMessage = null;
  if (control) {
    if (control.hasError('required')) {
      validationMessage = CommonConstants.ERROR_INPUT_REQUIRED;
    }

    if (control.hasError('minlength')) {
      validationMessage = `Minimum length ${control.errors.minlength.requiredLength}`;
    }

    if (control.hasError('maxlength')) {
      validationMessage = `Max length exceeded, only ${control.errors.maxlength.requiredLength} characters allowed.`;
    }

    if (control.hasError('min')) {
      validationMessage = `Giá trị nhỏ nhất cho phép là ${control.errors.min.min}`;
    }

    if (control.hasError('max')) {
      validationMessage = `Giá trị lớn nhất cho phép là ${control.errors.max.max}`;
    }

    if (control.hasError('email')) {
      validationMessage = CommonConstants.ERROR_EMAIL_INVALID;
    }

    if (control.hasError('alphabet')) {
      validationMessage = 'This field must be alphabet letters';
    }

    if (control.hasError('alphanumeric')) {
      validationMessage = 'This field must be number or alphabet letters';
    }

    if (control.hasError('numeric')) {
      validationMessage = 'This field must be number';
    }

    if (control.hasError('existedUnitCode')) {
      validationMessage = 'Mã ĐVQL đã tồn tại';
    }

    if (control.hasError('existedStationCode')) {
      validationMessage = 'Mã trạm đã tồn tại';
    }

    if (control.hasError('existedCustomerCode')) {
      validationMessage = 'Mã KH đã tồn tại';
    }

    if (control.hasError('existedMeterCode')) {
      validationMessage = 'Mã công tơ đã tồn tại';
    }

    if (control.hasError('existedUserName')) {
      validationMessage = 'Tên đăng nhập đã tồn tại';
    }

    if (control.hasError('existedMeasuringPointCode')) {
      validationMessage = 'Mã điểm đo đã tồn tại';
    }

    if (control.hasError('existedCooperativeCode')) {
      validationMessage = 'Mã HTX đã tồn tại';
    }

    if (control.hasError('invalidPeriod')) {
      validationMessage = 'Ngày kết thúc phải lớn hơn ngày hiện tại';
    }

    if (control.hasError('existedStationCode')) {
      validationMessage = 'Mã Trạm đã tồn tại';
    }
  }

  return validationMessage;
}
